import * as THREE from "three";

const light = new THREE.AmbientLight( 0x404040 ); // soft white light
const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
light.add( directionalLight );
directionalLight.position.set(5,5,5);
const pointLight  = new THREE.PointLight(0xffffff,1); 
pointLight.position.set(2,2,2);

light.add( pointLight );
//sombra
directionalLight.castShadow = true; // default false
directionalLight.shadow.mapSize.width = 512; // default
directionalLight.shadow.mapSize.height = 512; // default
directionalLight.shadow.camera.near = 0.5; // default
directionalLight.shadow.camera.far = 20; // default



export default light;